module.exports = __webpack_public_path__ + "static/img/ly.d089645e.svg";